import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useNetworkManager } from '../../hooks/useNetworkManager';
import ButtonStyled from '../shared/button/Button';
import styles from './MobileBanner.module.scss';

const MobileBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { brandingData } = useNetworkManager();

  const appLink = useMemo(
    () => (brandingData ? brandingData[0].install_app_cta_url : ''),
    [brandingData],
  );

  return (
    <div className={styles.banner}>
      <div className={styles.textContainer}>
        <p className={styles.title}>{t('mobileHeader.title')}</p>
        <p className={styles.subtitle}>{t('mobileHeader.subtitle')}</p>
      </div>
      <div className={styles.buttonContainer}>
        <ButtonStyled onClick={() => (window.location.href = appLink)}>
          OPEN
        </ButtonStyled>
      </div>
    </div>
  );
};

export default MobileBanner;
